export default {
  LEARN: "Learn",
};
